import { useEffect, useState } from "react";
import { _Test } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { SpanRender } from "../../../theme/Component/SpanRender";
import { MASK_MYEDITOR } from "../../../theme/Component/BasicTable";
import { ViewQuestion } from "./ViewQuestion";

interface Props {
    idTest: number;
    exportResult: any;
    hideTittle?: boolean;
    isComplete?:any;
}
export const TestEncuesta = ({ idTest, exportResult, hideTittle ,isComplete}: Props) => {

    const _test = useDataBean(_Test);
    const { bean, setBean, lista, setLista } = _test;
    const [prueba, setPrueba] = useState<any>({});

    const UNIQUE = 1; // unica respuesta
    const MULTIPLE = 2; // multiple respuesta
    const BOOLEAN = 3; // verdadero / falso
    const OPEN = 4; // pregunta abierta

    useEffect(() => {
        if (idTest) {
            _test.instance.getProofTestEvaluation(idTest).then(
                (resp: any) => {
                    setPrueba(resp);
                }
            )
        }
    }, [idTest])
    useEffect(() => {
        if (lista.length > 0) {
            exportResult(lista);
            validResponses();
        }
    }, [lista])

    const setResponse = (resp: any) => {
        const id = resp.IDTestQuestion;
        // Remueve cualquier item con el mismo IDTestQuestion y agrega el nuevo
        setLista([
            ...lista.filter((val) => val.IDTestQuestion !== id),
            resp
        ]);
    }

    const validResponses=()=>{
        const preguntas = prueba.Questions;
        let preNo = preguntas.length;
        let resp = 0;
        preguntas.forEach(element => {
            if(element.DataBeanProperties.QuestionType == BOOLEAN)
            {
                    let pre = getPregunta(element.DataBeanProperties.IDTestQuestion);
                    if(pre)
                    {
                        let co = 0;
                        if(pre?.OptionResponse?.option != undefined )
                        {
                            co=1;
                            let pres = pre?.OptionResponse;
                            let op = element.DataBeanProperties;
                            // console.log(pres);
                            
                            if(pres.option === true)
                            if(op.RequireAnswer == 1)
                            {
                                co = 0;                                                                
                                if(pres.justifica == "")
                                    co =0;              
                                else
                                    co=1;                  
                            }
                            
                        }
                        resp +=co;
                    }
            }
            else if(element.DataBeanProperties.QuestionType == UNIQUE)
            {
                    let pre = getPregunta(element.DataBeanProperties.IDTestQuestion);
                    if(pre)
                    {
                        // console.log(pre);
                        if(pre?.OptionResponse>0)
                            resp++;
                    }
            }
            else if(element.DataBeanProperties.QuestionType == MULTIPLE)
            {
                    let pre = getPregunta(element.DataBeanProperties.IDTestQuestion);
                    if(pre)
                    {
                        if(pre?.OptionResponse)
                        {
                            // console.log(pre);
                            let arr = pre?.OptionResponse;
                            if(arr.length>0)
                                resp++;

                        }
                    }
            }
            else if(element.DataBeanProperties.QuestionType == OPEN)
            {
                    let pre = getPregunta(element.DataBeanProperties.IDTestQuestion);
                    if(pre)
                    {
                        if(pre?.OptionResponse != "")
                        {                            
                                resp++;
                        }
                    }
            }
            
        });

        // console.log("RESPUESTAS => ",resp);
        
        console.log("Completo ...",resp,preNo);
        
        if(isComplete)
        {
            isComplete(resp == preNo);
        }
    }

    const getPregunta=(id)=>{
        let p = null;
        if(lista.length>0)
        {
            
            
            let pregunta = lista.filter(item => item.IDTestQuestion == id);
            if(pregunta.length>0)
                p= pregunta[0];

        }
        

        return p;
    }




    return (
        <div className="row">
            {hideTittle ? null :
                <div className="col-md-12">
                    <h5>
                        <SpanRender value={prueba.Description} mask={MASK_MYEDITOR} />
                    </h5>
                    <hr />
                </div>
            }
            <div className="col-md-12">
                {prueba.Questions &&
                    <>
                        {prueba.Questions.map((item, index) => {
                            return (
                                <ViewQuestion key={index} question={item.DataBeanProperties} response={setResponse} />
                            )
                        })}
                    </>
                }
            </div>
            {/* <div className="col-md-12">
                <PrintJson json={lista}/>
            </div> */}

        </div>
    )
}